import { Component, OnInit,Output,Input,EventEmitter, OnDestroy } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { Router } from '@angular/router';
@Component({
    selector: 'app-bar',
    templateUrl: './bar.component.html',
    styleUrls: ['./bar.component.scss'],
    standalone: false
})
export class BarComponent implements OnInit {
  @Output() pageChange = new EventEmitter<string>();
  @Output() showPatDetails = new EventEmitter();
  @Input('switchpage') switch: Subject<string>;
  currentPage ="Calendar";

  constructor(private router: Router) {
    
   }

  ngOnInit(): void {
    this.currentPage= this.isRouteActive('appointments')? 'Calendar':'exams'
  }

  
  setPage(page:string){
    this.currentPage=page;
    this.pageChange.emit(page);
  }

  
  isRouteActive(route: string): boolean {
    return this.router.url === `/${route}`;
  }

}
